import { useTranslation } from "react-i18next";
import type { CommissionState } from "@/lib/types";

const STATE_TONE: Record<CommissionState, string> = {
  expected: "bg-[#FEF3C7] text-[#92400E]",
  due: "bg-[#E0F2EF] text-[#1E6B65]",
  partial: "bg-[#E0F2EF] text-[#1E6B65]",
  paid: "bg-[#DCF5E6] text-[#166534]",
  void: "bg-[#EEF1F0] text-[#4F5E5B]",
};

/** The payout status of one commission (owner rules 9-10): «Ожидается» until its
 * lines are completed, «К выплате» once they are, «Выплачено» when paid out. */
export function PayoutState({ state }: { state: CommissionState }) {
  const { t } = useTranslation();
  return (
    <span
      className={`inline-block whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-semibold ${STATE_TONE[state]}`}
    >
      {t(`agentsPage.state.${state}`)}
    </span>
  );
}
